import { ValidationMessages } from "./type-definition";

export const VALIDATION_MESSAGES: ValidationMessages = new Map([
  ['required', { messageKey: 'REQUIRED_FIELD' }],
  [
    'minlength',
    {
      messageKey: 'INVALID_MINLENGTH',
      validatorErrorsKey: ['requiredLength'],
    },
  ],
  [
    'maxlength',
    {
      messageKey: 'MAX_LENGTH',
      validatorErrorsKey: ['requiredLength'],
    },
  ],
  ['email', { messageKey: 'INVALID_EMAIL' }],
  [
    'min',
    {
      messageKey: 'MIN_NUMBER',
      validatorErrorsKey: ['min'],
    },
  ],
  [
    'max',
    {
      messageKey: 'MAX_NUMBER',
      validatorErrorsKey: ['max'],
    },
  ],
  ['invalidEmail', {messageKey : "INVALID_EMAIL"}],
  ['notMatch' , {messageKey : "NOT_MATCH"}],
  ["atLeastOneValue" , {messageKey : "REQUIRED_AT_LEAST_ONE"}],
  ['invalidPassword', {messageKey : "INVALID_PASSWORD"}],
  ['lettersOnlyValidator', {messageKey: "LETTERS_ONLY"}],
  ['invalidCountryName', {messageKey: "INVALID_COUNTRY_NAME"}],
  ['invalidGender', {messageKey: "INVALID_GENDER"}],
  ['notInteger', {messageKey: "NOT_INTEGER"}],
  ['invalidPhoneNumber', {messageKey: "INVALID_PHONE_NUMBER"}],
  ['invalidTwoLetters', {messageKey: "NOT_TWO_LETTERS"}],
  ['invalidAlphaNumeric', {messageKey: "NOT_ALPHA_NUMERIC"}],
  ['invalidUsername', {messageKey: "INVALID_USERNAME"}],
  ['invalidId', {messageKey: "INVALID_ID"}],
  ['inValidArabicLetters', {messageKey: "INVALID_ARABIC_LETTERS"}],
  ['inValidEnglishLetters', {messageKey: "INVALID_ENGLISH_LETTERS"}],
  ['inValidArabicAlphaNumericLetters', {messageKey: "INVALID_ARABIC_ALPHANUMERIC_LETTERS"}],
  ['inValidEnglishAlphaNumericLetters', {messageKey: "INVALID_ENGLISH_ALPHANUMERIC_LETTERS"}],
  ['invalidEducationalLevel', {messageKey: "INVALID_EDUCATIONAL_LEVEL"}],
  ['inValidNumericOrAlphanumeric', {messageKey: "INVALID_NUMERIC_OR_ALPHANUMERIC"}],
  ['invalidText', {messageKey: "INVALID_TEXT"}],
  ['customMin', {messageKey: "minSessionsPerDayError", validatorErrorsKey: ['min']}],
  ['customMax', {messageKey: "maxSessionsPerDayError", validatorErrorsKey: ['max']}],
  ['customMinLength', {messageKey: "minLengthOfSessionPeriodError", validatorErrorsKey: ['min']}],
  ['customMaxLength', {messageKey: "maxLengthOfSessionPeriodError", validatorErrorsKey: ['max']}],
  ['atLeastOneControl', {messageKey: "ID_OR_EMAIL_REQUIRED"}],
  ['invalidPromoCodeUsageCount', {messageKey: "INVALID_USAGE_COUNT"}]
]);